import { render, staticRenderFns } from "./myReward.vue?vue&type=template&id=035bdd0c&scoped=true&"
import script from "./myReward.vue?vue&type=script&lang=js&"
export * from "./myReward.vue?vue&type=script&lang=js&"
import style0 from "./myReward.vue?vue&type=style&index=0&id=035bdd0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035bdd0c",
  null
  
)

export default component.exports